<template>
  <f-card>
    <v-row>
      <v-col cols="12">
        <f-card-title>{{ $t("pages.orders.new.totalValue") }}</f-card-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :disabled="true"
          outlined
          dense
          v-model="total"
          hide-details="auto"
        />
      </v-col>
    </v-row>
  </f-card>
</template>

<script>
import numberFormater from "../../helpers/number_formater";

export default {
  data: () => ({
    total: 0,
    selInterval: null,
  }),
  created() {
    // console.log(this.$store.state)
  },
  computed: {
    order() {
      return this.$store.state.order.view;
    },
  },
  created() {
    this.selInterval = setInterval(() => {
      if (this.$store.state.order.view.total) {
        this.total = numberFormater.money(this.$store.state.order.view.total, {
          decimalLength: 2,
        });
      }
    }, 800);
  },
  // watch: {
  //     '$store.state.order.view.total': function( value ){
  //         console.log( 'se liga aew' )
  //         this.total = numberFormater.money( value )
  //     }
  // },
  destroyed() {
    clearInterval(this.selInterval);
  },
};
</script>
